import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const en = {
    nav: {
        home: "Home", features: "Features", journal: "Journal",
        about: "About", community: "Community", pricing: "Pricing",
        contact: "Contact", support: "Support", getFemcare: "Get Femcare",
    },
    common: {
        readMore: "Read more", search: "Search articles…",
        all: "All articles", loading: "Loading…",
        send: "Send", submit: "Submit", cancel: "Cancel",
        backToBlog: "Back to Journal", min: "min",
        viewAll: "View all articles", by: "by",
    },
    home: {
        badge: "Women's Health Reimagined",
        title1: "Your private", title2: "women's health",
        title3: "companion.",
        sub: "Cycle tracking, fertility predictions, pregnancy support, and AI-powered insights — all in one beautifully designed app trusted by women across India and beyond.",
        ctaPrimary: "Get Femcare Premium", ctaSecondary: "Explore features",
        socialProof: "Built for every stage of your health journey",
        statTrust: "Women trust Femcare", statAccuracy: "Prediction accuracy",
        statSymptoms: "Symptoms tracked", statRating: "App Store rating",
    },
    pricing: {
        section: "Pricing", heroTitle: "Femcare Premium",
        heroSub: "Advanced reports, AI insights & beautiful wellness exports.",
        alreadyPremium: "Already Premium? Sign in",
        monthly: "Monthly", yearly: "Yearly",
        perMonth: "per month", perYear: "per year",
        off72: "72% off", whatsIncluded: "What's included",
        addDaughter: "Add Daughter Care",
        daughterLocked: "Select Premium above to unlock Daughter Care add-on.",
        requiresPremium: "Requires Premium",
        monthlyAddon: "Monthly add-on", yearlyAddon: "Yearly add-on",
        buyNow: "Buy Now", chooseAPlan: "Choose a plan",
        billingMode: "Billing", oneTime: "One-time", autoRenew: "Auto-renew (Subscription)",
        faqTitle: "Frequently asked.",
    },
    blog: {
        section: "The Journal", title1: "Stories, science",
        title2: "& sisterhood.",
        sub: "Evidence-based articles on cycle health, fertility, pregnancy and the moments in between — written by OB-GYNs and the Femcare team.",
        featured: "Featured", noResults: "No articles found.",
        comments: "Comments", leaveComment: "Leave a comment",
        commentName: "Name", commentEmail: "Email", commentMessage: "Your thoughts",
        commentSubmit: "Post comment", commentPending: "Your comment is awaiting moderation.",
        searchPh: "Search journal…", filterByTag: "Filter by tag",
    },
    account: {
        section: "Your account", title1: "Welcome back.",
        title2: "Find your subscription.",
        sub: "Enter the email you used at checkout. We'll show your active subscriptions and let you re-send any receipt.",
        emailPh: "you@example.com", lookup: "Find my orders",
        notFound: "No orders found",
        notFoundSub: "We couldn't find any paid orders for",
        seePlans: "See plans", paidOn: "Paid", resend: "Resend receipt", sent: "Sent ✓",
    },
};

const hi = {
    nav: {
        home: "मुख्य", features: "विशेषताएँ", journal: "जर्नल",
        about: "हमारे बारे में", community: "समुदाय", pricing: "मूल्य",
        contact: "संपर्क", support: "सहायता", getFemcare: "Femcare पाएँ",
    },
    common: {
        readMore: "और पढ़ें", search: "लेख खोजें…",
        all: "सभी लेख", loading: "लोड हो रहा है…",
        send: "भेजें", submit: "जमा करें", cancel: "रद्द करें",
        backToBlog: "जर्नल पर वापस", min: "मिनट",
        viewAll: "सभी लेख देखें", by: "द्वारा",
    },
    home: {
        badge: "महिला स्वास्थ्य नई परिभाषा",
        title1: "आपकी निजी", title2: "महिला स्वास्थ्य",
        title3: "साथी।",
        sub: "साइकल ट्रैकिंग, फर्टिलिटी अनुमान, गर्भावस्था सहायता और AI-संचालित अंतर्दृष्टि — एक खूबसूरत ऐप में, जिस पर भारत और दुनिया भर की महिलाएँ भरोसा करती हैं।",
        ctaPrimary: "Femcare Premium लें", ctaSecondary: "विशेषताएँ देखें",
        socialProof: "20 लाख+ महिलाओं की पसंद",
        statTrust: "महिलाएँ Femcare पर भरोसा करती हैं", statAccuracy: "अनुमान सटीकता",
        statSymptoms: "लक्षण ट्रैक होते हैं", statRating: "ऐप स्टोर रेटिंग",
    },
    pricing: {
        section: "मूल्य", heroTitle: "Femcare Premium",
        heroSub: "उन्नत रिपोर्ट, AI अंतर्दृष्टि और डॉक्टर-तैयार एक्सपोर्ट।",
        alreadyPremium: "पहले से Premium? साइन इन करें",
        monthly: "मासिक", yearly: "वार्षिक",
        perMonth: "प्रति माह", perYear: "प्रति वर्ष",
        off72: "72% छूट", whatsIncluded: "क्या शामिल है",
        addDaughter: "Daughter Care जोड़ें",
        daughterLocked: "Daughter Care ऐड-ऑन अनलॉक करने के लिए ऊपर Premium चुनें।",
        requiresPremium: "Premium ज़रूरी है",
        monthlyAddon: "मासिक ऐड-ऑन", yearlyAddon: "वार्षिक ऐड-ऑन",
        buyNow: "अभी खरीदें", chooseAPlan: "एक प्लान चुनें",
        billingMode: "बिलिंग", oneTime: "एक बार", autoRenew: "ऑटो-रिन्यू (सब्सक्रिप्शन)",
        faqTitle: "अक्सर पूछे जाने वाले प्रश्न।",
    },
    blog: {
        section: "जर्नल", title1: "कहानियाँ, विज्ञान",
        title2: "और सहेलियों का साथ।",
        sub: "साइकल हेल्थ, फर्टिलिटी, गर्भावस्था और बीच के पलों पर सबूत-आधारित लेख — OB-GYNs और Femcare टीम द्वारा लिखित।",
        featured: "फ़ीचर्ड", noResults: "कोई लेख नहीं मिला।",
        comments: "टिप्पणियाँ", leaveComment: "टिप्पणी छोड़ें",
        commentName: "नाम", commentEmail: "ईमेल", commentMessage: "आपके विचार",
        commentSubmit: "टिप्पणी पोस्ट करें", commentPending: "आपकी टिप्पणी मॉडरेशन में है।",
        searchPh: "जर्नल खोजें…", filterByTag: "टैग द्वारा फ़िल्टर करें",
    },
    account: {
        section: "आपका खाता", title1: "वापसी पर स्वागत है।",
        title2: "अपनी सब्सक्रिप्शन ढूँढें।",
        sub: "वही ईमेल दर्ज करें जो चेकआउट के समय इस्तेमाल किया था। हम आपकी सक्रिय सब्सक्रिप्शन दिखाएँगे और रसीद फिर से भेजने देंगे।",
        emailPh: "aap@example.com", lookup: "मेरे ऑर्डर ढूँढें",
        notFound: "कोई ऑर्डर नहीं मिला",
        notFoundSub: "हमें इसके लिए कोई भुगतान किया ऑर्डर नहीं मिला:",
        seePlans: "प्लान देखें", paidOn: "भुगतान", resend: "रसीद फिर से भेजें", sent: "भेजा ✓",
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: { en: { translation: en }, hi: { translation: hi } },
        fallbackLng: "en",
        supportedLngs: ["en", "hi", "bn", "ta", "te", "mr", "gu", "kn", "ml", "or", "pa", "ur", "es", "pt", "fr", "de", "ar", "id", "tr", "ru", "vi", "ja", "ko", "zh"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "femcare_lang",
            caches: ["localStorage"],
        },
    });

export default i18n;
